module.exports = __webpack_public_path__ + "media/images/professional-guides-96541c8700a03a2ad833eefc1b628676.jpg";